import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Logo from './../logo/Logo'
import './styles.scss'
import Heading from '../heading/Heading';
import Texts from './../../static-data/texts.json';
import Text from './../text/Text';
import { convertPrice } from './../.././/services/convertPrice';


const StepsSummaryBox = () => {
    const dispatch = useDispatch()

    let activeContract     = useSelector(state => state.selectedLease)
    let [ load, setLoad ]  = useState(false);
    let productPrice       = useSelector(state => state.productPrice)
    let productPriceEnd    = useSelector(state => state.productPriceEnd)
    let tax             = useSelector(state => state.tax)
    let leasingTime     = useSelector(state => state.leasingTime)
    let finalRate       = useSelector(state => state.finalRate)
    let rateFrequency   = useSelector(state => state.rateFrequency)
    let chargePrice     = useSelector(state => state.chargePrice)
    let repurchase     = useSelector(state => state.repurchase)


    let convertValue = (value) => {

        if (  typeof(value) != 'array'  ) {
            let val = value.toString() ;
            val = val.replace(/\s/g, '');
            val = val.replace(',', '.');
            val = val.replace('zł', '');
            val = parseFloat(val);
            let input = parseFloat(val).toFixed(2);
            return convertPrice(input);
        }
        return null;
    }

    useEffect(() => {
        if ( !load ) {
            if (  typeof(productPriceEnd) != 'array'  ) {
                // let val = productPriceEnd.toString() ;
                // val = val.replace(/\s/g, '');
                // val = val.replace(',', '.');
                // val = val.replace('zł', '');
                // val = parseFloat(val);
                // let input = parseFloat(val).toFixed(2);
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: repurchase })
            }
            setLoad( true );
        } 
    }, [load])

    return (
        <section className="steps-summary-box">
            <Heading title={ activeContract == 'tradycyjny' ? "Leasing Tradycyjny (z opcją nabycia)" : "Najem Flexrent"} big={true} />
            <div className="box">
                <div className="row">
                     <div className="col">
                        Cena przedmiotu bez VAT-u
                    </div>
                    <div className="col">
                        { convertValue(productPrice) } zł
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        Opłata początkowa
                    </div>
                    <div className="col">
                        { chargePrice }
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        Opłata za opracowanie
                    </div>
                    <div className="col">
                        { tax }
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        { activeContract == 'tradycyjny' ? 'Podstawowy' : 'Minimalny'} Okres Umowy w miesiącach
                    </div>
                    <div className="col">
                        { leasingTime != '' ? leasingTime : '18' }
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        Rata leasingu
                    </div>
                    <div className="col">
                        <h2>{ convertValue(finalRate) } zł</h2>
                        <p>{ rateFrequency }</p>
                    </div>
                </div>
                { activeContract == 'tradycyjny' && 
                    <div className="row">
                        <div className="col">
                            Wartość końcowa
                        </div>
                        <div className="col">
                            <h2>{ convertValue(repurchase) } zł</h2>
                        </div>
                    </div>
                }
                
            </div>

            {  activeContract == 'tradycyjny' && rateFrequency == 'miesięcznie' &&
                <Text text={ Texts.summaryOne } />
            }
            {  activeContract == 'tradycyjny' && rateFrequency == 'kwartalnie' &&
                <Text text={ Texts.summaryTwo } />
            }
            { activeContract == 'nowoczesny' && rateFrequency == 'miesięcznie' &&
                <Text text={ Texts.summaryThree } />
            }
            {  activeContract == 'nowoczesny' && rateFrequency == 'kwartalnie' &&
                <Text text={ Texts.summaryFour } />
            }
        </section>
    )
}

export default StepsSummaryBox;